import React, { useState, useEffect } from 'react';
import { Mosaic } from 'react-loading-indicators'; // Double check this import
import './LoadingScreen.css';

function LoadingScreen({ onLoadingComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    console.log("Loading Screen Mounted"); // Check your browser console (F12)

    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          setTimeout(() => {
            if (onLoadingComplete) onLoadingComplete();
          }, 500);
          return 100;
        }
        return prev + 1; // Slowed down for testing
      });
    }, 50); // Updates every 50ms

    return () => clearInterval(progressInterval);
  }, [onLoadingComplete]);

  return (
    <div className="loading-screen" style={{  color: 'white' }}>
      <div className="loading-content">
        
        {/* If this is blank, the library might not be loading correctly */}
        <div className="indicator-container" style={{ minHeight: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Mosaic color="#32c3cd" size="medium" text="" textColor="" />
        </div>

        <div className="loading-title">
          <h1>Rahim Biswas</h1>
          <p className="subtitle" style={{ color: '#000000' }}>GeoAI Engineer</p>
        </div>

        <div className="progress-container">
          <div className="progress-bar" style={{ background: 'rgba(255,255,255,0.2)', height: '4px', width: '200px' }}>
            <div 
              className="progress-fill" 
              style={{ 
                width: `${progress}%`, 
                backgroundColor: '#32c3cd', 
                height: '100%',
                transition: 'width 0.1s linear' 
              }}
            ></div>
          </div>
          <p>{progress}%</p>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;